"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var react_slick_1 = __importDefault(require("react-slick"));
var View_1 = __importDefault(require("../View"));
var EditButton_1 = __importDefault(require("../EditButton"));
var LoaderModule_1 = __importDefault(require("../../../common/LoaderModule"));
var ThreeDButton_1 = __importDefault(require("../ThreeDButton"));
var ZoomableImage_1 = __importDefault(require("../ZoomableImage"));
var RasterizingMessage_1 = __importDefault(require("../RasterizingMessage"));
var product_1 = require("../../ducks/product");
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var products_custom_views_1 = __importDefault(require("../../../../mocks/products-custom-views"));
var views_module_scss_1 = __importDefault(require("./views.module.scss"));
var selectors_1 = require("../../../common/selectors");
var Views = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var views = (0, react_redux_1.useSelector)(product_1.viewsSelector);
    var editPath = (0, react_redux_1.useSelector)(product_1.editPathSelector);
    var loading = (0, react_redux_1.useSelector)(product_1.productLoadingSelector);
    var ready = (0, react_redux_1.useSelector)(product_1.productReadySelector);
    var singular = (0, react_redux_1.useSelector)(product_1.singularSelector);
    var banned = (0, react_redux_1.useSelector)(product_1.productBannedSelector);
    var isMobile = (0, react_redux_1.useSelector)(selectors_1.isMobileSelector);
    var _a = views.large, largeViews = _a === void 0 ? [] : _a, _b = views.small, smallViews = _b === void 0 ? [] : _b, _c = views.detailed, detailedViews = _c === void 0 ? [] : _c, defaultSide = views.defaultSide, viewAlt = views.alt, viewTitle = views.title;
    var _d = (0, react_1.useState)(defaultSide), activeIndex = _d[0], setActiveIndex = _d[1];
    var sliderRef = (0, react_1.useRef)(null);
    var handleClick = function (index) { return function (event) {
        var _a;
        event.preventDefault();
        (_a = sliderRef.current) === null || _a === void 0 ? void 0 : _a.slickGoTo(index);
        setActiveIndex(index);
    }; };
    (0, react_1.useEffect)(function () {
        if (!ready) {
            dispatch((0, product_1.getViews)());
        }
    }, [product_1.getViews, ready]);
    var customViews = products_custom_views_1.default[singular];
    var customSmallViews = Array.isArray(customViews)
        ? customViews.map(function (item) { return item.smallView; })
        : [];
    var customLargeViews = Array.isArray(customViews)
        ? customViews.map(function (item) { return item.largeView; })
        : [];
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(views_module_scss_1.default.root, (loading || !ready) && views_module_scss_1.default.rootLoading) },
        react_1.default.createElement("div", { className: views_module_scss_1.default.navigation },
            react_1.default.createElement("div", { className: views_module_scss_1.default.smallViews }, __spreadArray(__spreadArray([], smallViews, true), customSmallViews, true).map(function (view, i) {
                return (react_1.default.createElement("button", { key: i, onClick: handleClick(i), className: (0, classnames_1.default)(views_module_scss_1.default.smallView, i === activeIndex ? views_module_scss_1.default.smallViewActive : '') },
                    react_1.default.createElement(View_1.default, { src: view, alt: viewAlt, title: viewTitle })));
            })),
            react_1.default.createElement(EditButton_1.default, { className: views_module_scss_1.default.editButton, path: editPath }),
            react_1.default.createElement(ThreeDButton_1.default, { className: views_module_scss_1.default.threeDButton })),
        react_1.default.createElement("div", { className: views_module_scss_1.default.main },
            loading && react_1.default.createElement(LoaderModule_1.default, { className: views_module_scss_1.default.loader }),
            !ready && react_1.default.createElement(RasterizingMessage_1.default, { className: views_module_scss_1.default.rasterizingMessage }),
            react_1.default.createElement(react_slick_1.default, { ref: sliderRef, initialSlide: defaultSide, arrows: false, speed: 500, dots: false, draggable: false, responsive: [
                    {
                        breakpoint: 940,
                        settings: {
                            dots: true,
                        },
                    },
                ] },
                largeViews.map(function (view, i) {
                    return (react_1.default.createElement(ZoomableImage_1.default, { key: i, smallImage: view, largeImage: detailedViews[i], alt: viewAlt, title: viewTitle, className: views_module_scss_1.default.largeSlide, isDisabled: banned || isMobile }));
                }),
                customLargeViews.map(function (view, i) {
                    return (react_1.default.createElement(ZoomableImage_1.default, { key: i, smallImage: view, largeImage: view, alt: viewAlt, title: viewTitle, className: views_module_scss_1.default.largeSlide, isDisabled: banned || isMobile }));
                })),
            react_1.default.createElement("div", { id: "portal", className: views_module_scss_1.default.portal }))));
};
exports.default = (0, withErrorBoundary_1.default)(Views);
